import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.map";
export default function (s) {
  return s.match(/.{6}/g).map(function (x) {
    return "#" + x;
  });
}